import Close from '@mui/icons-material/Close';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  styled,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useAppointmentsCalendarContext } from 'components/appointment_calendar_context';
import Localization from 'l18n/l18n';
import CalendarSettings from 'models/calendar';
import { useSnackbar } from 'notistack';
import * as React from 'react';

const  WeekendDaySelectorDialog = React.forwardRef((props,ref) => {
  const { calendarSettings, setCalendarSettings } = useAppointmentsCalendarContext();
  const { handleCancel } = props;
  const { enqueueSnackbar } = useSnackbar();

  const handleCheckboxChange = (event) => {
    const weekDays = calendarSettings.weekDays;

    // check if the user trying to execude all days
    if (
      weekDays.filter((day) => day.executed == true).length >=
        weekDays.length - 1 &&
      event.target.checked == true
    ) {
      enqueueSnackbar(Localization.translate['can_not_execute_all_days'], {
        variant: 'warning',
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        preventDuplicate: true,
        autoHideDuration: 2000,
      });
      return;
    }

    weekDays.map((day) => {
      // if the changed input name match one of the weekDays id
      if (day.id == Number(event.target.name)) {
        day.executed = event.target.checked;
      }
    });

    setCalendarSettings(calendarSettings);

  };

  const StyledFormControlLabel = styled((props) => (
    <FormControlLabel {...props} />
  ))(({ theme, checked }) => ({
    '.MuiFormControlLabel-label': checked && {
      // Change color of the label if the input is checked
      color: '#279BFF',
    },
  }));

  React.useImperativeHandle(ref, () => ({
    save() {
      SaveWeekends();
    }
  }));
  const SaveWeekends = ()=>{
    CalendarSettings.changeWeekends({week_ends:calendarSettings.weekDays}).then((result) => {
      setCalendarSettings(calendarSettings);
    }).catch(err=>{
      enqueueSnackbar(Localization.translate['error'], {
        variant: 'error',
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        preventDuplicate: true,
        autoHideDuration: 2000,
      });
      console.log('error',err);
    });
  };
  function MyFormControlLabel(props) {
    return (
      <StyledFormControlLabel
        checked={props.control.props.checked}
        {...props}
      />
    );
  }

  const ChackBoxStyles = styled('span')(({ theme }) => ({
    borderRadius: 5,
    width: 24,
    height: 24,
    border: '1px solid #757575',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
  }));

  const ChackBoxCheckedStyles = styled(ChackBoxStyles)({
    backgroundColor: 'white',
    borderColor: '#279BFF',
    '&:before': {
      display: 'block',
      width: 24,
      height: 24,
      borderRadius: 5,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23279BFF'/%3E%3C/svg%3E\")",
      content: '""',
    },
  });

  return (
    <>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11} className="draggable-dialog-title">
            {Localization.translate['vications']}
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => handleCancel()}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <FormControl
          required
          component="fieldset"
          sx={{ m: 0 }}
          variant="standard"
        >
          <FormGroup>
            {calendarSettings.weekDays.map((day) => {
              return (
                <MyFormControlLabel
                  key={day.id}
                  control={
                    <Checkbox
                      checked={day.executed}
                      checkedIcon={<ChackBoxCheckedStyles />}
                      icon={<ChackBoxStyles />}
                      onChange={handleCheckboxChange}
                      name={String(day.id)}
                    />
                  }
                  label={day.name}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </DialogContent>
    </>
  );
});
WeekendDaySelectorDialog.displayName ='WeekendDaySelectorDialog';
export default WeekendDaySelectorDialog;
